import {
  SET_LEVEL_SEARCH_FILTER,
  SET_SCHOOL_YEAR_SEARCH_FILTER,
  SET_SUBJECT_SEARCH_FILTER,
  RESET_SEARCH_FILTERS,
  SET_SEARCH_TERM,
  SET_SEARCH_TYPE,
} from '@state/actions/searchActions'

const initialSearchState = {
  subjectFilter: undefined,
  schoolYearFilter: undefined,
  levelFilter: undefined,
  type: 'all',
  term: '',
}

/**
 * Reducer
 */
const searchReducer = (state, action) => {
  switch (action.type) {
    case SET_SUBJECT_SEARCH_FILTER:
      return {
        ...state,
        subjectFilter: action.payload,
      }

    case SET_SCHOOL_YEAR_SEARCH_FILTER:
      return {
        ...state,
        schoolYearFilter: action.payload,
      }

    case SET_LEVEL_SEARCH_FILTER:
      return {
        ...state,
        levelFilter: action.payload,
      }

    case RESET_SEARCH_FILTERS:
      return {
        ...state,
        subjectFilter: undefined,
        schoolYearFilter: undefined,
        levelFilter: undefined,
      }

    case SET_SEARCH_TERM:
      return {
        ...state,
        term: action.payload.term,
      }

    case SET_SEARCH_TYPE:
      return {
        ...state,
        type: action.payload.type,
      }

    default:
      return state
  }
}

export { initialSearchState, searchReducer }
